export default __webpack_public_path__ + "static/media/nt.66ea4919.webp";